// The token the Root Agent accepts from the website chatbot. Visitors are
// anonymous, so the widget asks PIMS's backend for one: the backend checks the
// page's site against the bot's allowed domains (the CORS Setting tab) and
// signs a short-lived token for this bot and this site. It is reused until
// shortly before it expires, so a visitor fetches about one every 15 minutes.
import { getApiUrl } from "./Api";

// Fetched again this long before it runs out, so a turn never starts with a
// token that is about to expire.
const REFRESH_MARGIN_MS = 60_000;

const tokens = new Map(); // botId -> { token, expiresAt } or the request in flight

export async function getWidgetAgentToken(botId) {
  const cached = tokens.get(botId);
  if (cached instanceof Promise) return cached;
  if (cached && cached.expiresAt - REFRESH_MARGIN_MS > Date.now()) {
    return cached.token;
  }

  // A bodiless POST is a simple request: no CORS preflight.
  const request = (async () => {
    const res = await fetch(
      `${getApiUrl()}/${encodeURIComponent(botId)}/agent-token`,
      { method: "POST" },
    );
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      throw new Error(data.error || `Could not get an agent token: ${res.status}`);
    }
    tokens.set(botId, { token: data.token, expiresAt: data.expires_at });
    return data.token;
  })();
  tokens.set(botId, request);
  try {
    return await request;
  } catch (err) {
    tokens.delete(botId);
    throw err;
  }
}
